import axios from 'axios';

const log = require("loglevel").getLogger("WidgetsService");
log.setLevel("error");

export const loadWidgetByName = name => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/widget/get`, {name})
		.then(async response => {
			const res = response.data;
			log.debug("WidgetsService -> loadWidgetByName -> return");
			return res;
		})
		.catch(response => {
			log.debug("WidgetsService -> loadWidgetByName -> error: ");
			log.debug(response);
			return null;
		});
};
